export default __webpack_public_path__ + "static/media/ExecutiveDashboard_Icon.d76bd0ac.png";